/**
 * Query-sleutels van werkplek v6. Eén plek, zodat de lijst na een
 * handeling in het midden ververst zonder dat de vlakken elkaar kennen.
 */
export const v6Sleutels = {
  alles: ["v6"] as const,
  lijst: ["v6", "lijst"] as const,
  zaak: (zaakId: string) => ["v6", "zaak", zaakId] as const,
  /** Alle zaken (sessie 72: na een herverbinding de open zaak bijtrekken). */
  zaken: ["v6", "zaak"] as const,
  concept: (zaakId: string) => ["v6", "concept", zaakId] as const,
  controles: (zaakId: string) => ["v6", "controles", zaakId] as const,
  copiloot: (zaakId: string) => ["v6", "copiloot", zaakId] as const,
  /** Sessie 73: klantkaart v6, één cache voor pagina Klanten en klantblok. */
  klantKaart: (klantId: string) => ["v6", "klantkaart", klantId] as const,
  klantKaartTijdlijn: (klantId: string) => ["v6", "klantkaart", klantId, "tijdlijn"] as const,
  klantenCijfers: ["v6", "klanten", "cijfers"] as const,
  klantenLijst: (zoek: string) => ["v6", "klanten", "lijst", zoek] as const,
  menutellers: ["werkplek", "menutellers"] as const,
};
